function SectionCandidateProfileInfo() {
    return (
        <>
            <h4 class="section-head-small mb-4">Profile Info</h4>
            <div class="twm-s-info-4">
                <div class="row">

                    <div class="col-md-6">
                        <div class="twm-s-info-inner">
                            <i class="fas fa-money-bill-wave"></i>
                            <span class="twm-title">Offered Salary</span>
                            <div class="twm-s-info-discription">$20 / Day</div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="twm-s-info-inner">
                            <i class="fas fa-clock"></i>
                            <span class="twm-title">Experience</span>
                            <div class="twm-s-info-discription">6 Year</div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="twm-s-info-inner">
                            <i class="fas fa-venus-mars"></i>
                            <span class="twm-title">Gender</span>
                            <div class="twm-s-info-discription">Male</div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="twm-s-info-inner">
                            <i class="fas fa-mobile-alt"></i>
                            <span class="twm-title">Phone</span>
                            <div class="twm-s-info-discription">+291  560 56456</div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="twm-s-info-inner">
                            <i class="fas fa-at"></i>
                            <span class="twm-title">Email</span>
                            <div class="twm-s-info-discription">thewebmaxdemo@gmail.com</div>
                        </div>
                    </div>
                    <div class="col-md-6">
                        <div class="twm-s-info-inner">
                            <i class="fas fa-book-reader"></i>
                            <span class="twm-title">Qualification</span>
                            <div class="twm-s-info-discription">MCA</div>
                        </div>
                    </div>
                    <div class="col-md-12">
                        <div class="twm-s-info-inner">

                            <i class="fas fa-map-marker-alt"></i>
                            <span class="twm-title">Address</span>
                            <div class="twm-s-info-discription">1363-1385 Sunset Blvd Angeles, CA 90026 ,USA</div>
                        </div>
                    </div>

                </div>

            </div>
        </>
    )
}

export default SectionCandidateProfileInfo;